import { testObjectHasKey } from '../../../lib/test-and-assert/test-base';
import { globalLogger } from '../../helper/global-logger';
import { satGlobals } from './sat-globals';

import translations from '../../../translations/trans_paths.json';

/**
 * returns some translated paths
 *
 * @param {String} path
 *
 * @return {string}
 */
function translatePath(path) {
    let locale = satGlobals.getLocale();

    if (!testObjectHasKey(translations, locale)) {
        globalLogger.log('get sat path fail - unsupported locale', JSON.stringify(locale));

        locale = 'en';
    }

    const paths = translations[locale];

    if (testObjectHasKey(paths, path)) {
        path = paths[path];
    } else if (path === 'logout' || path === '/logout') {
        // do nothing
    } else {
        // there are no different locale versions of the logout path
        // TODO: this might be logged way too often. pls check later
        globalLogger.log('get sat path fail - missing path for locale', {
            locale: locale,
            path: path,
        });
    }

    return path;
}

export { translatePath };
